import { Column } from "@bryntum/schedulerpro";

// any custom column implement can extend to this class, to get access the project and onLoad event
// the onLoad gets called after view gets displayed
export default class ColumnBase extends Column {
  static get $name() {
    return "ColumnBase";
  }

  onLoad() {
    //
  }
}

ColumnBase.initClass();
